<template>
    <div class="max-w-lg w-full mx-auto px-4">
        <div class="space-y-2">
            <h1 class="text-gray-800 font-semibold text-3xl">{{ $t('success_payment.title') }}</h1>
            <h2 class="text-gray-800 font-medium">{{ $t('success_payment.subtitle') }}</h2>
            <p class="text-gray-600 text-sm">{{ $t('success_payment.text_1') }}</p>

            <p class="text-gray-600 text-sm mt-4">{{ $t('success_payment.text_2') }} <a :href="publicUrl('contacts')" target="_blank" class="text-blue-500 hover:underline">{{ $t('success_payment.text_3') }}</a>.</p>

            <p class="text-gray-600 text-sm">{{ $t('success_payment.text_4') }} <router-link to="/subscription" class="text-blue-500 hover:underline">{{ $t('success_payment.text_5') }}</router-link>.</p>

            <router-link to="/" class="mt-3 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                {{ $t('success_payment.to_galleries') }}
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import {trackFacebookEvent} from "@/_helpers/facebook-pixel";

export default defineComponent({
    name: "UserSubscriptionThankYouPage",

    mounted() {
        // Трекінг підписки через Facebook Pixel
        trackFacebookEvent('Subscribe', {
            content_name: 'Subscription Purchase',
            content_category: 'Subscription',
            value: 0,
            currency: 'USD'
        });

        setTimeout(() => {
            this.fetchUser({token: this.userToken})
        }, 1000);
    },

    computed: {
        ...mapGetters({
            userToken: "user/token",
        }),
    },

    methods: {
        ...mapActions({
            "fetchUser": "user/fetchUser",
        }),

        publicUrl(url: string): string {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
    }
});
</script>

<style scoped lang="scss">

</style>